export class Kelas {
  kelas: number;

  constructor(
    kelas: number
  ) {
    this.kelas = kelas;
  }
}
